$(document).ready(function() {
  

  $(".starmap-preview").css("opacity", "0");

  var starColor = "#4F4F4F",
      constColor = "#4F4F4F";
  
  var d = null,
      lat = null,
      lng = null;
  
  
      console.log("this is running")

      
      if($('.Product').hasClass('starmap-chain')) {
              
        /*var size = 6;
        var lineWidth = 1;
  		var zoomLevel = 4;
        var starLimit = 10;*/
        
        var size = 80;
        var lineWidth = 10;
  		var zoomLevel = 3;
        var starLimit = 8;
        var mapWidth = 1000;
        
      } else if($('.Product').hasClass('starmap-necklace')){
        
        var size = 80;
        var lineWidth = 10;
  		var zoomLevel = 3;
        var starLimit = 8;
        var mapWidth = 1000;
        
      } else if($('.Product').hasClass('starmap-prem-chain')){
        
        var size = 80;
        var lineWidth = 10;
  		var zoomLevel = 3;
        var starLimit = 8;
        var mapWidth = 1000;
        
      } else if($('.Product').hasClass('starmap-minimal')){
        
        var size = 80;
        var lineWidth = 10;
  		var zoomLevel = 3;
        var starLimit = 8;
        var mapWidth = 1000;
        
      } else if($('.Product').hasClass('starmap-ring')){
        
		var size = 80;
        var lineWidth = 10;
  		var zoomLevel = 3;
        var starLimit = 8;
        var mapWidth = 1000;
        
      } else{ 
        
        var size = 80;
        var lineWidth = 10;
  		var zoomLevel = 3;
        var starLimit = 8;
        var mapWidth = 1000;
        
      }
  
  
  var config = { 
  width: mapWidth,           // Default width, 0 = full parent element width; 
                      // height is determined by projection
  projection: "airy",    // Map projection used: see below
  projectionRatio: null,   // Optional override for default projection ratio
  transform: "equatorial", // Coordinate transformation: equatorial (default),
                           // ecliptic, galactic, supergalactic
  center: null,       // Initial center coordinates in set transform
                      // [longitude, latitude, orientation] all in degrees 
                      // null = default center [0,0,0]
  orientationfixed: true,  // Keep orientation angle the same as center[2]
  geopos: null,       // optional initial geographic position [lat,lon] in degrees, 
                      // overrides center
  follow: "zenith",   // on which coordinates to center the map, default: zenith, if location enabled, 
                      // otherwise center
  zoomlevel: zoomLevel,    // initial zoom level 0...zoomextend; 0|null = default, 1 = 100%, 0 < x <= zoomextend
  zoomextend: 10,     // maximum zoom level
  adaptable: true,    // Sizes are increased with higher zoom-levels
  interactive: false,  // Enable zooming and rotation with mousewheel and dragging
  form: false,         // Display form for interactive settings. Needs a div with
                      // id="celestial-form", created automatically if not present
  location: false,    // Display location settings. Deprecated, use formFields below
  formFields: {"location": false,  // Set visiblity for each group of fields with the respective id
               "general": false,  
               "stars": false,  
               "dsos": false,  
               "constellations": true,  
               "lines": true,  
               "other": true,  
               "download": false},  
  advanced: true,     // Display fewer form fields if false 
  daterange: [],      // Calender date range; null: displaydate-+10; [n<100]: displaydate-+n; [yr]: yr-+10; 
                      // [yr, n<100]: [yr-n, yr+n]; [yr0, yr1]  
  controls: false,     // Display zoom controls
  lang: "",           // Global language override for names, any name setting that has the chosen language available
                      // Default: desig or empty string for designations, other languages as used anywhere else
  culture: "",        // Source of constellations and star names, default "iau", other: "cn" Traditional Chinese   // ID of parent element, e.g. div, null = html-body
  datapath: "https://ofrohn.github.io/data",  // Path/URL to data files, empty = subfolder 'data'
  stars: {
    show: true,    // Show stars
    limit: starLimit,      // Show only stars brighter than limit magnitude
    colors: false,  // Show stars in spectral colors, if not use default color
    style: { fill: starColor, opacity: 1 }, // Default style for stars
    designation: false, // Show star names (Bayer, Flamsteed, Variable star, Gliese or designation, 
                       // i.e. whichever of the previous applies first); may vary with culture setting
    designationType: "desig",  // Which kind of name is displayed as designation (fieldname in starnames.json)
    designationStyle: { fill: "#ddddbb", font: "11px 'Palatino Linotype', Georgia, Times, 'Times Roman', serif", align: "left", baseline: "top" },
    designationLimit: 2.5,  // Show only names for stars brighter than nameLimit
    propername: false,   // Show proper name (if present)
    propernameType: "name", // Languge for proper name, default IAU name; may vary with culture setting 
                            // (see list below of languages codes available for stars)
    propernameStyle: { fill: "#ddddbb", font: "13px 'Palatino Linotype', Georgia, Times, 'Times Roman', serif", align: "right", baseline: "bottom" },
    propernameLimit: 1.5,  // Show proper names for stars brighter than propernameLimit
    size: size,       // Maximum size (radius) of star circle in pixels
    exponent: -0.28, // Scale exponent for star size, larger = more linear
    data: 'stars.6.json' // Data source for stellar data, 
                         // number indicates limit magnitude
  },
  dsos: {
    show: false,    // Show Deep Space Objects 
    limit: 6,      // Show only DSOs brighter than limit magnitude
    colors: false,  // // Show DSOs in symbol colors if true, use style setting below if false
    style: { fill: "#000000", stroke: "#000000", width: 2, opacity: 1 }, // Default style for dsos
    names: false,   // Show DSO names
    namesType: "name",  // Type of DSO ('desig' or language) name shown
                        // (see list below for languages codes available for dsos)
    nameStyle: { fill: "#000000", font: "11px Helvetica, Arial, serif", 
                 align: "left", baseline: "top" }, // Style for DSO names
    nameLimit: 6,  // Show only names for DSOs brighter than namelimit
    size: null,    // Optional seperate scale size for DSOs, null = stars.size
    exponent: 1.4, // Scale exponent for DSO size, larger = more non-linear
    data: 'dsos.bright.json', // Data source for DSOs, 
                              // opt. number indicates limit magnitude
    symbols: {  //DSO symbol styles, 'stroke'-parameter present = outline
      gg: {shape: "circle", fill: "#ff0000"},          // Galaxy cluster
      g:  {shape: "ellipse", fill: "#ff0000"},         // Generic galaxy
      s:  {shape: "ellipse", fill: "#ff0000"},         // Spiral galaxy
      s0: {shape: "ellipse", fill: "#ff0000"},         // Lenticular galaxy
      sd: {shape: "ellipse", fill: "#ff0000"},         // Dwarf galaxy
      e:  {shape: "ellipse", fill: "#ff0000"},         // Elliptical galaxy
      i:  {shape: "ellipse", fill: "#ff0000"},         // Irregular galaxy
      oc: {shape: "circle", fill: "#ffcc00", 
           stroke: "#ffcc00", width: 1.5},             // Open cluster
      gc: {shape: "circle", fill: "#ff9900"},          // Globular cluster
      en: {shape: "square", fill: "#ff00cc"},          // Emission nebula
      bn: {shape: "square", fill: "#ff00cc", 
           stroke: "#ff00cc", width: 2},               // Generic bright nebula
      sfr:{shape: "square", fill: "#cc00ff", 
           stroke: "#cc00ff", width: 2},               // Star forming region
      rn: {shape: "square", fill: "#00ooff"},          // Reflection nebula
      pn: {shape: "diamond", fill: "#00cccc"},         // Planetary nebula 
      snr:{shape: "diamond", fill: "#ff00cc"},         // Supernova remnant
      dn: {shape: "square", fill: "#999999", 
           stroke: "#999999", width: 2},               // Dark nebula grey
      pos:{shape: "marker", fill: "#cccccc", 
           stroke: "#cccccc", width: 1.5}              // Generic marker
    }
  },
  planets: {  //Show planet locations, if date-time is set
    show: false,
    // List of all objects to show
    which: ["sol", "mer", "ven", "ter", "lun", "mar", "jup", "sat", "ura", "nep"],
    // Font styles for planetary symbols
    symbols: {  // Character and color for each symbol in 'which' above (simple circle: \u25cf), optional size override for Sun & Moon
      "sol": {symbol: "\u2609", letter:"Su", fill: "#ffff00", size:""},
      "mer": {symbol: "\u263f", letter:"Me", fill: "#cccccc"},
      "ven": {symbol: "\u2640", letter:"V", fill: "#eeeecc"},
      "ter": {symbol: "\u2295", letter:"T", fill: "#00ccff"},
      "lun": {symbol: "\u25cf", letter:"L", fill: "#ffffff", size:""}, // overridden by generated crecent, except letter & size
      "mar": {symbol: "\u2642", letter:"Ma", fill: "#ff6600"},
      "cer": {symbol: "\u26b3", letter:"C", fill: "#cccccc"},
      "ves": {symbol: "\u26b6", letter:"Ma", fill: "#cccccc"},
      "jup": {symbol: "\u2643", letter:"J", fill: "#ffaa33"},
      "sat": {symbol: "\u2644", letter:"Sa", fill: "#ffdd66"},
      "ura": {symbol: "\u2645", letter:"U", fill: "#66ccff"},
      "nep": {symbol: "\u2646", letter:"N", fill: "#6666ff"},
      "plu": {symbol: "\u2647", letter:"P", fill: "#aaaaaa"},
      "eri": {symbol: "\u26aa", letter:"E", fill: "#eeeeee"}
    },
    symbolStyle: { fill: "#00ccff", font: "bold 17px 'Lucida Sans Unicode', Consolas, sans-serif", 
             align: "center", baseline: "middle" },
    symbolType: "symbol",  // Type of planet symbol: 'symbol' graphic planet sign, 'disk' filled circle scaled by magnitude
                           // 'letter': 1 or 2 letters S Me V L Ma J S U N     
    names: false,          // Show name in nameType language next to symbol
    nameStyle: { fill: "#00ccff", font: "14px 'Lucida Sans Unicode', Consolas, sans-serif", align: "right", baseline: "top" },
    namesType: "desig"     // Language of planet name (see list below of language codes available for planets), 
                           // or desig = 3-letter designation
  },
  constellations: {
    names: false,      // Show constellation names 
    namesType: "iau", // Type of name Latin (iau, default), 3 letter designation (desig) or other language (see list below)
    nameStyle: { fill:"#000000", align: "center", baseline: "middle", 
                 font: ["14px Helvetica, Arial, sans-serif",  // Style for constellations
                        "12px Helvetica, Arial, sans-serif",  // Different fonts for diff.
                        "11px Helvetica, Arial, sans-serif"]},// ranked constellations
    lines: true,   // Show constellation lines, style below
    lineStyle: { stroke: constColor, width: lineWidth, opacity: 1 }, 
    bounds: false, // Show constellation boundaries, style below
    boundStyle: { stroke: "#000000", width: 0.5, opacity: 0.8, dash: [2, 4] }
  },  
  mw: {
    show: true,     // Show Milky Way as filled multi-polygon outlines 
    style: { fill: "#ffffff", opacity: 0.15 }  // Style for MW layers
  },
  lines: {  // Display & styles for graticule & some planes
    graticule: { show: false, stroke: "#000000", width: 0.6, opacity: 0.8,   
      // grid values: "outline", "center", or [lat,...] specific position
      lon: {pos: [""], fill: "#eee", font: "10px Helvetica, Arial, sans-serif"}, 
      // grid values: "outline", "center", or [lon,...] specific position
      lat: {pos: [""], fill: "#eee", font: "10px Helvetica, Arial, sans-serif"}},    
    equatorial: { show: false, stroke: "#aaaaaa", width: 1.3, opacity: 0.7 },  
    ecliptic: { show: false, stroke: "#66cc66", width: 1.3, opacity: 0.7 },     
    galactic: { show: false, stroke: "#cc6666", width: 1.3, opacity: 0.7 },    
    supergalactic: { show: false, stroke: "#cc66cc", width: 1.3, opacity: 0.7 }
  },
  background: {        // Background style
    fill: "#000000",   // Area fill
    opacity: 0, 
    stroke: "#000000", // Outline
    width: 1.5
  }, 
  horizon: {  //Show horizon marker, if location is set and map projection is all-sky
    show: false, 
    stroke: "#cccccc", // Line
    width: 1.0, 
    fill: "#000000",   // Area below horizon
    opacity: 0.5
  },  
  daylight: {  //Show day sky as a gradient, if location is set and map projection is hemispheric
    show: false
  }
};

// Display map with the configuration above or any subset thereof
Celestial.display(config);
  
    /*$('.Product__SlideshowNavArrow').on('click', function(starColor, constColor){
    
    console.log("nav")
    if ($(".Product__SlideItem--image.is-selected").hasClass("matteProdImg")){
    console.log("nav arrows clicked and matte black image")
    
    starColor = "#bfbfbf";
   	constColor = "#bfbfbf";
      
    var matteConfig = {
    stars: {  // Show stars in spectral colors, if not use default color
    	style: { fill: starColor, opacity: 1 }, // Default style for stars
      	size: size
  	},
    constellations: {       
  		lineStyle: { stroke: constColor, width: lineWidth, opacity: 1 }
  	}
    };
      console.log(matteConfig)
      Celestial.reload(matteConfig)
    } else {
        starColor = "#4F4F4F";
   	constColor = "#4F4F4F";
      
    var matteConfig = {
    stars: {  // Show stars in spectral colors, if not use default color
    	style: { fill: starColor, opacity: 1 } // Default style for stars
  	},
    constellations: {       
  		lineStyle: { stroke: constColor, width: lineWidth, opacity: 1 }
  	}
    };
      console.log(matteConfig)
      Celestial.reload(matteConfig)
    }
    
  });*/
  
      $('.Product__SlideshowNavImage').on('click', function(starColor, constColor){
    
    console.log("nav")
    if ($(this).hasClass("matteProdImg")){
    console.log("nav arrows clicked and matte black image")
    
    starColor = "#bfbfbf";
   	constColor = "#bfbfbf";
      
    var matteConfig = {
    stars: {  // Show stars in spectral colors, if not use default color
    	style: { fill: starColor, opacity: 1 }, // Default style for stars
      	size: size
  	},
    constellations: {       
  		lineStyle: { stroke: constColor, width: lineWidth, opacity: 1 }
  	}
    };
      console.log(matteConfig)
      Celestial.reload(matteConfig)
    } else {
        starColor = "#4F4F4F";
   	constColor = "#4F4F4F";
      
    var matteConfig = {
    stars: {  // Show stars in spectral colors, if not use default color
    	style: { fill: starColor, opacity: 1 } // Default style for stars
  	},
    constellations: {       
  		lineStyle: { stroke: constColor, width: lineWidth, opacity: 1 }
  	}
    };
      console.log(matteConfig)
      Celestial.reload(matteConfig)
    }
    
  });
                  mapboxgl.accessToken = 'pk.eyJ1IjoiY3VzdG9tY3VmZiIsImEiOiJja2FrczA0cXAwbmM2MnR0ZGR1dnljdGx0In0._EkFqlWTPsGRXyxeRebiYg';
const geocoder = new MapboxGeocoder({
accessToken: mapboxgl.accessToken,
types: 'country,region,place,postcode,locality,neighborhood'
});
 
geocoder.addTo('#geocoder');        
  

function findLocation() {
                document.querySelector('.mapboxgl-ctrl-geocoder--input').id = 'mapbox-search';
                document.querySelector('.suggestions').id = 'suggestionsBox';
                geocoder.query(document.getElementById("mapbox-search").value);
                document.getElementById("suggestionsBox").style.display = 'none';
            }
          $('#findLocationBtn').click(findLocation)

              

  
              geocoder.on('result', function(ev, curve) {
                var latString = ev.result.geometry.coordinates[1];
                var lngString = ev.result.geometry.coordinates[0];
                $('.mapboxgl-ctrl-geocoder--input').blur();

                lat = JSON.stringify(latString);
                lng = JSON.stringify(lngString);
                
                $('.starmap-configurator').attr("data-latitude", lat);
                $('.starmap-configurator').attr("data-longitude", lng);
                
                  	let yearVal = parseInt($('#year').val());
  					let monthVal = parseInt($('#month').val() - 1);
  					let dateVal = parseInt($('#day').val());
  
                    d = new Date(yearVal, monthVal, dateVal)

                    console.log(d)  

                  	Celestial.skyview({date: d, location:[lat, lng]})

                  	console.log("Latitude/longitude: " + lat + " - " + lng)
                  	console.log("Date: " + d)
 
               
            });
  
  			$('#year').on('change', function(ev, curve) {
  				var latString = $('.starmap-configurator').data("latitude");
                var lngString = $('.starmap-configurator').data("longitude");
                $('.mapboxgl-ctrl-geocoder--input').blur();

                lat = JSON.stringify(latString);
                lng = JSON.stringify(lngString);
                
                
                  	let yearVal = parseInt(this.value);
  					let monthVal = parseInt($('#month').val() - 1);
  					let dateVal = parseInt($('#day').val());
  
                    d = new Date(yearVal, monthVal, dateVal)

                    console.log(d)  

                  	Celestial.skyview({date: d, location:[lat, lng]})
            });
    			$('#month').on('change', function(ev, curve) {
				var latString = $('.starmap-configurator').data("latitude");
                var lngString = $('.starmap-configurator').data("longitude");
                $('.mapboxgl-ctrl-geocoder--input').blur();

                lat = JSON.stringify(latString);
                lng = JSON.stringify(lngString);
                
                
                
                  	let yearVal = parseInt($('#year').val());
  					let monthVal = parseInt($(this).val() - 1);
  					let dateVal = parseInt($('#day').val());
  
                    d = new Date(yearVal, monthVal, dateVal)

                    console.log(d)  

                  	Celestial.skyview({date: d, location:[lat, lng]})
            });
    			$('#day').on('change', function(ev, curve) {
				var latString = $('.starmap-configurator').data("latitude");
                var lngString = $('.starmap-configurator').data("longitude");
                $('.mapboxgl-ctrl-geocoder--input').blur();

                lat = JSON.stringify(latString);
                lng = JSON.stringify(lngString);
                
                
                
                  	let yearVal = parseInt($('#year').val());
  					let monthVal = parseInt($('#month').val() - 1);
  					let dateVal = parseInt($(this).val());
  
                    d = new Date(yearVal, monthVal, dateVal)

                    console.log(d)  

                  	Celestial.skyview({date: d, location:[lat, lng]})
            });
  
  /*
  const textInput = document.querySelector('.text-input');
const dateInput = document.querySelector('.datepicker-input');
  dateInput.addEventListener('change', event => {
  textInput.value = event.target.value;
                    var lat = $('.starmap-configurator').data("latitude");
                var lng = $('.starmap-configurator').data("longitude");
                $('.mapboxgl-ctrl-geocoder--input').blur();
				
    var currentDate = $(".datepicker-input").val();
    
                var d = new Date(currentDate);
Celestial.skyview({date: d, location:[lat, lng]})

console.log("Latitude/longitude: " + lat + " - " + lng)
console.log("Date: " + d)
});
textInput.addEventListener('input', event => {
  const value = textInput.value.trim();
  dateInput.value = value.match(/^\d{4}-\d{2}-\d{2}$/) ? value : '';
}); */
  
  $(".map-const-setting input").change(function() {
    console.log("changed")
    	$('#constellations-lines').click();

});
    $(".map-grid-setting input").change(function() {
    	$('#lines-graticule-show').click()

});
  function addToCartNew(){
    var canvas = document.querySelectorAll(".starmap-preview canvas");
    var result = canvas[0].toDataURL()
    console.log("canvas-result", result)
    
    var resultCrop = $(".starmap-preview canvas").croppie({
			viewport: {
				width: 1000,
				height: 1000,
				type: 'circle'
			},
			enableExif: true
		});
    
      //console.log(resultCrop)
    var data = {
      upload_preset: "fjnxktwl", // the unsigned image preset within cloudinary
      tags: "foo", // any tags you wish to apply
      context: "photo=phototitle",
      file: result // the BASE64 encoded image file http://stackoverflow.com/questions/6978156/get-base64-encode-file-data-from-input-form
    }


    // standard Jquery ajax post
    console.log("test")
    jQuery.post("https://api.cloudinary.com/v1_1/dln60oxil/upload", data).done(function(data) {
      console.log("image sent");
    }).then(function(data) {
        console.log("secure url", data.secure_url) // addToCart is the ajax add to cart post function (whatever function your theme uses, modified to accept an the returned image)
        $('#starmap-img-src').val(data.secure_url)
        $('#Product__AddToCart').click();
        setTimeout(function(){
          var windowWidth = window.innerWidth;
          if(windowWidth <= 1139){
            var popupElement = document.querySelector('.variant-popup-customization');
            if(popupElement){
                document.dispatchEvent(new CustomEvent("product:added", {
                  bubbles: true,
                  detail: {
                    quantity: 1,
                  },
                }));
                document.body.style.overflow = 'unset';
              popupElement.classList.remove('active');
              removeActiveClass('.variant-popup-body-item');
              document.querySelectorAll('.variant-popup-body-item')[0].classList.add('active');
            }
          }
        }, 1000);
    }); 
    
  }
  
    $('#starmap-complete').click(function(){
       addToCartNew()
    //$('#Product__AddToCart').click();
    });
  
    });

// $(document).on('click', '#starmap-complete', function(){    
//       //addToCartNew()
//    $('#Product__AddToCart').click();
//   });